import React, { useState, useEffect } from "react";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import bg from "assets/bg.png";
import logo from "assets/logo.png";
import smile from "assets/smile.png";
import sad from "assets/sad.png";
import banner from "assets/banner.jpg";

function Result(props) {

  const [phoneDisable, setPhoneDisable] = useState(true);

  
  useEffect(() => {
    
    if (props.validPhone) {
      setPhoneDisable(false)
    } else {
      setPhoneDisable(true)
    }
  })

  return (
    <div className="container resultScreen">
      <div className="columns">
        <div className="column logoHold">
          <img src={logo} />
        </div>

        <div className="column resultContent">
          <div className="columns is-multiline">
            <div className="column is-12 emoji">
              {props.resultCode == 1 ? (
                <img src={smile} />
              ) : props.resultCode == 2 ? (
                <img src={sad} />
              ) : props.resultCode == 3 ? (
                <img src={sad} />
              ) : null}
            </div>

            <div className="column is-12 resultText">
              {props.resultCode == 1 && props.userRight ? (
                <div>
                  {!props.phoneGet ? (
                    <div>
                      <h4>Tebrikler!</h4>
                      <p>
                        Büyük ödüllü Milliyet özel yarışmasına katılmaya hak
                        kazandın!
                        <br />
                        Telefon numaranı paylaş ve Hadi’yi indir, büyük ödüle 1
                        adım daha yaklaş.{" "}
                      </p>
                    </div>
                  ) : (
                  <div>
                    <h4>Tebrikler!</h4>
                    <p>
                      Büyük ödüllü yarışmaya katılmaya hak
                      kazandın...
                      <br />
                      Hadi uygulamasını indir, büyük ödülü kazan
                    </p>
                  </div>
                )}
                </div>
              ) : props.resultCode == 2 && props.userRight ? (
                <div>
                  <h4>Elendin ama üzülme!</h4>
                  <p>
                    Hadi’de kazandıracak çok yarışma var! <br />
                    Bugün şansını yeniden denemeyi unutma!
                  </p>
                </div>
              ) : !props.userRight ? (
                <div>
                  <h4>Bugünlük hakkın bitti</h4>
                  <p>
                    Hadi’de kazandıracak çok yarışma var! <br />
                    Yarın şansını yeniden denemeyi unutma!
                  </p>
                </div>
              ) : null}
            </div>
            {props.resultCode == 1 && props.userRight ? (
              <div className="phoneForm column is-12">
                {!props.phoneGet ? (
                  <div>
                    <div className="form-div">
                    <PhoneInput
                      defaultCountry="TR"
                      placeholder="Telefon Numaranızı Giriniz"
                      value={props.phoneNumber}
                      onKeyDown={event => props.keydown(event)}
                      onChange={event => props.getNumber(event)}
                      limitMaxLength={true}
                    />
                      {/* <NumberFormat
                        format="(###) (###) ###-####"
                        mask="_"
                        placeholder=".. (…) ……."
                        className="form-phone-input"
                        onChange={event => props.getNumber(event)}
                        onValueChange={event => props.getPhoneNF(event)}
                      /> */}
                      <a onClick={props.sendNumber} disabled={phoneDisable}>
                        <span>Gönder</span>
                      </a>
                    </div>
                    <div className="terms">
                      <label className="container-checkbox">
                        <input
                          type="checkbox"
                          checked={props.kvkk}
                          onChange={event => props.getKvkk(event)}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <a onClick={props.openModal}>
                        KVKK uyarınca, kişisel verilerimin <br />
                        paylaşılmasını ve işlenmesini onaylıyorum.
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="columns note">
                    <div className="column is-12 cta">
                      <button
                        className="button start"
                        onClick={props.startClick}
                      >
                        Yeniden Başla
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : props.resultCode == 2 && props.userRight ? (
              <div className="columns note">
                <div className="column is-12 cta">
                  <button className="button start" onClick={props.startClick}>
                    Yeniden Başla
                  </button>

                  <div className="column is-12 bannerWrapper">
                    <div className="columns bannerHold">
                    <a href="http://www.hadilive.com" target="_blank">
                      <div className="column">
                        <img src={banner} />
                      </div> 
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>



      </div>
    </div>
  );
}

export default Result;
